!(function () {
  window._qqWechatEmotionParser = {};
  window.qqWechatEmotionParser = function () {};
})();

!(function () {
  window._qqWechatEmotionParser.emotion_map = [
    [
      { sym: '/::)', en: '[Smile]', cn: '[微笑]' },
      { sym: '/::~', en: '[Grimace]', cn: '[撇嘴]' },
      { sym: '/::B', en: '[Drool]', cn: '[色]' },
      { sym: '/::|', en: '[Scowl]', cn: '[发呆]' },
      { sym: '/:8-)', en: '[CoolGuy]', cn: '[得意]' },
      { sym: '/::<', en: '[Sob]', cn: '[流泪]' },
      { sym: '/::$', en: '[Shy]', cn: '[害羞]' },
      { sym: '/::X', en: '[Silent]', cn: '[闭嘴]' },
      { sym: '/::Z', en: '[Sleep]', cn: '[睡]' },
      { sym: "/::'(", en: '[Cry]', cn: '[大哭]' },
      { sym: '/::-|', en: '[Awkward]', cn: '[尴尬]' },
      { sym: '/::@', en: '[Angry]', cn: '[发怒]' },
      { sym: '/::P', en: '[Tongue]', cn: '[调皮]' },
      { sym: '/::D', en: '[Grin]', cn: '[呲牙]' },
      { sym: '/::O', en: '[Surprise]', cn: '[惊讶]' },
    ],
    [
      { sym: '/::(', en: '[Frown]', cn: '[难过]' },
      { sym: '/::+', en: '[Ruthless]', cn: '[酷]' },
      { sym: '/:-b', en: '[Blush]', cn: '[囧]' },
      { sym: '/::Q', en: '[Scream]', cn: '[抓狂]' },
      { sym: '/::T', en: '[Puke]', cn: '[吐]' },
      { sym: '/:,@P', en: '[Chuckle]', cn: '[偷笑]' },
      { sym: '/:,@-D', en: '[Joyful]', cn: '[愉快]' },
      { sym: '/::d', en: '[Slight]', cn: '[白眼]' },
      { sym: '/:,@o', en: '[Smug]', cn: '[傲慢]' },
      { sym: '/::g', en: '[Hungry]', cn: '[饥饿]' },
      { sym: '/:|-)', en: '[Drowsy]', cn: '[困]' },
      { sym: '/::!', en: '[Panic]', cn: '[惊恐]' },
      { sym: '/::L', en: '[Sweat]', cn: '[流汗]' },
      { sym: '/::>', en: '[Laugh]', cn: '[憨笑]' },
      { sym: '/::,@', en: '[Commando]', cn: '[悠闲]' },
    ],
    [
      { sym: '/:,@f', en: '[Determined]', cn: '[奋斗]' },
      { sym: '/::-S', en: '[Scold]', cn: '[咒骂]' },
      { sym: '/:?', en: '[Shocked]', cn: '[疑问]' },
      { sym: '/:,@x', en: '[Shhh]', cn: '[嘘]' },
      { sym: '/:,@@', en: '[Dizzy]', cn: '[晕]' },
      { sym: '/::8', en: '[Tormented]', cn: '[疯了]' },
      { sym: '/:,@!', en: '[Toasted]', cn: '[衰]' },
      { sym: '/:!!!', en: '[Skull]', cn: '[骷髅]' },
      { sym: '/:xx', en: '[Hammer]', cn: '[敲打]' },
      { sym: '/:bye', en: '[Wave]', cn: '[再见]' },
      { sym: '/:wipe', en: '[Speechless]', cn: '[擦汗]' },
      { sym: '/:dig', en: '[NosePick]', cn: '[抠鼻]' },
      { sym: '/:handclap', en: '[Clap]', cn: '[鼓掌]' },
      { sym: '/:&-(', en: '[Shame]', cn: '[糗大了]' },
      { sym: '/:B-)', en: '[Trick]', cn: '[坏笑]' },
    ],
    [
      { sym: '/:<@', en: '[Bah！L]', cn: '[左哼哼]' },
      { sym: '/:@>', en: '[Bah！R]', cn: '[右哼哼]' },
      { sym: '/::-O', en: '[Yawn]', cn: '[哈欠]' },
      { sym: '/:>-|', en: '[Pooh-pooh]', cn: '[鄙视]' },
      { sym: '/:P-(', en: '[Shrunken]', cn: '[委屈]' },
      { sym: "/::'|", en: '[TearingUp]', cn: '[快哭了]' },
      { sym: '/:X-)', en: '[Sly]', cn: '[阴险]' },
      { sym: '/::*', en: '[Kiss]', cn: '[亲亲]' },
      { sym: '/:@x', en: '[Wrath]', cn: '[吓]' },
      { sym: '/:8*', en: '[Whimper]', cn: '[可怜]' },
      { sym: '/:pd', en: '[Cleaver]', cn: '[菜刀]' },
      { sym: '/:<W>', en: '[Watermelon]', cn: '[西瓜]' },
      { sym: '/:beer', en: '[Beer]', cn: '[啤酒]' },
      { sym: '/:basketb', en: '[Basketball]', cn: '[篮球]' },
      { sym: '/:oo', en: '[PingPong]', cn: '[乒乓]' },
    ],
    [
      { sym: '/:coffee', en: '[Coffee]', cn: '[咖啡]' },
      { sym: '/:eat', en: '[Rice]', cn: '[饭]' },
      { sym: '/:pig', en: '[Pig]', cn: '[猪头]' },
      { sym: '/:rose', en: '[Rose]', cn: '[玫瑰]' },
      { sym: '/:fade', en: '[Wilt]', cn: '[凋谢]' },
      { sym: '/:showlove', en: '[Lips]', cn: '[嘴唇]' },
      { sym: '/:heart', en: '[Heart]', cn: '[爱心]' },
      { sym: '/:break', en: '[BrokenHeart]', cn: '[心碎]' },
      { sym: '/:cake', en: '[Cake]', cn: '[蛋糕]' },
      { sym: '/:li', en: '[Lightning]', cn: '[闪电]' },
      { sym: '/:bome', en: '[Bomb]', cn: '[炸弹]' },
      { sym: '/:kn', en: '[Dagger]', cn: '[刀]' },
      { sym: '/:footb', en: '[Soccer]', cn: '[足球]' },
      { sym: '/:ladybug', en: '[Ladybug]', cn: '[瓢虫]' },
      { sym: '/:shit', en: '[Poop]', cn: '[便便]' },
    ],
    [
      { sym: '/:moon', en: '[Moon]', cn: '[月亮]' },
      { sym: '/:sun', en: '[Sun]', cn: '[太阳]' },
      { sym: '/:gift', en: '[Gift]', cn: '[礼物]' },
      { sym: '/:hug', en: '[Hug]', cn: '[拥抱]' },
      { sym: '/:strong', en: '[ThumbsUp]', cn: '[强]' },
      { sym: '/:weak', en: '[ThumbsDown]', cn: '[弱]' },
      { sym: '/:share', en: '[Shake]', cn: '[握手]' },
      { sym: '/:v', en: '[Peace]', cn: '[胜利]' },
      { sym: '/:@)', en: '[Fight]', cn: '[抱拳]' },
      { sym: '/:jj', en: '[Beckon]', cn: '[勾引]' },
      { sym: '/:@@', en: '[Fist]', cn: '[拳头]' },
      { sym: '/:bad', en: '[Pinky]', cn: '[差劲]' },
      { sym: '/:lvu', en: '[RockOn]', cn: '[爱你]' },
      { sym: '/:no', en: '[Nuh-uh]', cn: '[NO]' },
      { sym: '/:ok', en: '[OK]', cn: '[OK]' },
    ],
    [
      { sym: '/:love', en: '[InLove]', cn: '[爱情]' },
      { sym: '/:<L>', en: '[Blowkiss]', cn: '[飞吻]' },
      { sym: '/:jump', en: '[Waddle]', cn: '[跳跳]' },
      { sym: '/:shake', en: '[Tremble]', cn: '[发抖]' },
      { sym: '/:<O>', en: '[Aaagh!]', cn: '[怄火]' },
      { sym: '/:circle', en: '[Twirl]', cn: '[转圈]' },
      { sym: '/:kotow', en: '[Kotow]', cn: '[磕头]' },
      { sym: '/:turn', en: '[Dramatic]', cn: '[回头]' },
      { sym: '/:skip', en: '[JumpRope]', cn: '[跳绳]' },
      { sym: '/:oY', en: '[Surrender]', cn: '[投降]' },
      { sym: '/:#-0', en: '[Hooray]', cn: '[激动]' },
      { sym: '/:hiphot', en: '[Meditate]', cn: '[乱舞]' },
      { sym: '/:kiss', en: '[Smooch]', cn: '[献吻]' },
      { sym: '/:<&', en: '[TaiChi L]', cn: '[左太极]' },
      { sym: '/:&>', en: '[TaiChi R]', cn: '[右太极]' },
    ],
    [
      { sym: '', en: '[Hey]', cn: '[嘿哈]' },
      { sym: '', en: '[Facepalm]', cn: '[捂脸]' },
      { sym: '', en: '[Smirk]', cn: '[奸笑]' },
      { sym: '', en: '[Smart]', cn: '[机智]' },
      { sym: '', en: '[Concerned]', cn: '[皱眉]' },
      { sym: '', en: '[Yeah!]', cn: '[耶]' },
      { sym: '', en: '[Chicken]', cn: '[鸡]' },
      { sym: '', en: '[Packet]', cn: '[红包]' },
      { sym: '', en: '[Rich]', cn: '[發]' },
      { sym: '', en: '[Pup]', cn: '[小狗]' },
      { sym: '', en: '[OnLooker]', cn: '[吃瓜]' },
      { sym: '', en: '[GoForIt]', cn: '[加油]' },
      { sym: '', en: '[Sweats]', cn: '[汗]' },
      { sym: '', en: '[OMG]', cn: '[天啊]' },
      { sym: '', en: '[Emm]', cn: '[Emm]' },
    ],
    [
      { sym: '', en: '[Respect]', cn: '[社会社会]' },
      { sym: '', en: '[Doge]', cn: '[旺柴]' },
      { sym: '', en: '[NoProb]', cn: '[好的]' },
      { sym: '', en: '[MyBad]', cn: '[打脸]' },
      { sym: '', en: '[Wow]', cn: '[哇]' },
      { sym: '', en: '[Boring]', cn: '[翻白眼]' },
      { sym: '', en: '[Awesome]', cn: '[666]' },
      { sym: '', en: '[LetMeSee]', cn: '[让我看看]' },
      { sym: '', en: '[Sigh]', cn: '[叹气]' },
      { sym: '', en: '[Hurt]', cn: '[苦涩]' },
      { sym: '', en: '[Broken]', cn: '[裂开]' },
    ],
  ];
})();
!(function () {
  function Trie() {
    this.words = 0;
    this.empty = 1;
    this.index = 0;
    this.children = {};
  }

  Trie.prototype = {
    insert: function (str, pos, idx) {
      if (str.length === 0) {
        return;
      }
      var T = this;
      var k;
      var child;

      if (pos === undefined) {
        pos = 0;
      }
      if (pos === str.length) {
        T.index = idx;
        return;
      }
      k = str[pos];
      if (T.children[k] === undefined) {
        T.children[k] = new Trie();
        T.empty = 0;
        T.children[k].words = this.words + 1;
      }
      child = T.children[k];
      child.insert(str, pos + 1, idx);
    },

    build: function (arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = 0; j < arr[i].length; j++) {
          for (var k in arr[i][j]) {
            var item = arr[i][j][k];
            if (item) {
              this.insert(item, 0, [i, j, k]);
              // emotion_list.push({key: emotion_map[i][j][k], i: i, j: j});
            }
          }
        }
      }
      // var len = arr.length;
      // for (var i = 0; i < len; i++) {
      //     this.insert(arr[i], 0, i);
      // }
    },

    searchOne: function (str, pos) {
      if (pos === undefined) {
        pos = 0;
      }
      var result = {};
      if (str.length === 0) return result;
      var T = this;
      var child;
      var k;
      result.arr = [];
      k = str[pos];
      child = T.children[k];
      if (child !== undefined && pos < str.length) {
        return child.searchOne(str, pos + 1);
      }
      if (child === undefined && T.empty === 0) return result;
      if (T.empty == 1) {
        result.arr[0] = pos - T.words;
        result.arr[1] = T.index;
        result.words = T.words;
        return result;
      }
      return result;
    },

    search: function (str) {
      if (this.empty == 1) return [];
      var len = str.length;
      var searchResult = [];
      var tmp;
      for (var i = 0; i < len - 1; i++) {
        tmp = this.searchOne(str, i);
        if (typeof tmp.arr !== "undefined" && tmp.arr.length > 0) {
          searchResult.push(tmp.arr);
          i = i + tmp.words - 1;
        }
      }
      return searchResult;
    },
  };

  if (typeof window !== "undefined") {
    window._qqWechatEmotionParser.Trie = Trie;
  }
})();

!(function () {
  var emotion_map, trie, emotion_list, Trie;

  if (window !== "undefined") {
    emotion_map = window._qqWechatEmotionParser.emotion_map;
    Trie = window._qqWechatEmotionParser.Trie;
    build();
    window.qqWechatEmotionParser = qqWechatEmotionParser;
  }

  function build() {
    // emotion_list = keys(emotion_map);
    trie = new Trie();
    trie.build(emotion_map);
  }

  function qqWechatEmotionParser(str) {
    var indices = trie.search(str);
    indices.reverse().map(function (idx) {
      var indexes = idx[1];
      var item = emotion_map[indexes[0]][indexes[1]];
      // var pos = idx[0], emotion = emotion_list[idx[1]];
      var img = `<img class="wx-emo-img" style="background-position: ${
        -20 * indexes[1]
      }px ${
        -20 * indexes[0]
      }px" src="https://wx.qq.com/zh_CN/htmledition/v2/images/spacer.gif" alt="${
        item[indexes[2]]
      }">`;
      // img = '<img src="' + emotion_map[emotion] + '" alt="' + emotion + '">';
      str = splice(str, idx[0], item[indexes[2]].length, img);
    });
    return str;
  }

  function splice(str, index, count, add) {
    return str.slice(0, index) + add + str.slice(index + count);
  }

  function keys(map) {
    var list = [];
    for (var k in map) {
      if (map.hasOwnProperty(k)) list.push(k);
    }
    return list;
  }
})();



// WEBPACK FOOTER //
// ./src/js/parseWxEmo.js